import { array, object } from "yup";

export const validations = object().shape({
  targetingGroups: array().min(1, "Please select at least one targeting group."),
});
